var map = {
	"./ExemptedEnergyRating.svg": 10461,
	"./Map.svg": 49476,
	"./access24Hour.svg": 29649,
	"./airConditioning.svg": 69400,
	"./airport.svg": 14120,
	"./alarmSystem.svg": 93333,
	"./atm.svg": 24428,
	"./balcony.svg": 50546,
	"./bank.svg": 11867,
	"./bar.svg": 9029,
	"./bicycle_parking.svg": 2727,
	"./bikeRacks.svg": 94615,
	"./boat.svg": 28276,
	"./build_route.svg": 73403,
	"./bus.svg": 46578,
	"./cafe.svg": 25218,
	"./canteen.svg": 58132,
	"./car_repair.svg": 63070,
	"./car_wash.svg": 83631,
	"./catering.svg": 8333,
	"./charging_station.svg": 87973,
	"./cinema.svg": 7993,
	"./cleaning.svg": 35702,
	"./clinic.svg": 19481,
	"./closedCircuitTelevision.svg": 61552,
	"./coffee_shop.svg": 83369,
	"./conferenceRooms.svg": 38855,
	"./cooling.svg": 52156,
	"./copying_facilities.svg": 55943,
	"./coworking.svg": 22328,
	"./coworkingSpace.svg": 9078,
	"./currency_exchange.svg": 1396,
	"./default.svg": 14443,
	"./dentist.svg": 61141,
	"./disabled.svg": 44905,
	"./electricCarCharge.svg": 90081,
	"./elevator.svg": 92105,
	"./enclosedProperty.svg": 34976,
	"./fast_food.svg": 52784,
	"./fiberInternet.svg": 8842,
	"./fitness_centre.svg": 22566,
	"./furnished.svg": 61368,
	"./gym.svg": 52283,
	"./hotDesk.svg": 20670,
	"./hotel.svg": 73704,
	"./itSupport.svg": 55996,
	"./kitchenette.svg": 43486,
	"./light_rail.svg": 1280,
	"./local_train.svg": 71667,
	"./lounge.svg": 73111,
	"./mall.svg": 13680,
	"./meetingRooms.svg": 12553,
	"./metro.svg": 41542,
	"./outdoorArea.svg": 22163,
	"./ownSignage.svg": 5870,
	"./parking.svg": 14535,
	"./petFriendly.svg": 88842,
	"./pharmacy.svg": 34997,
	"./phoneAnswering.svg": 93854,
	"./post_office.svg": 33210,
	"./postalFacilities.svg": 13333,
	"./privateOffices.svg": 85383,
	"./pub.svg": 67007,
	"./reception.svg": 52981,
	"./restaurant.svg": 63481,
	"./s-train.svg": 39839,
	"./secretarial.svg": 26928,
	"./shower.svg": 39921,
	"./spatialPlanning.svg": 35998,
	"./storage.svg": 72648,
	"./supermarket.svg": 23604,
	"./taxi.svg": 67874,
	"./telephoneSystem.svg": 90645,
	"./train.svg": 79953,
	"./tram.svg": 49989,
	"./trolleybus.svg": 67301,
	"./unfurnished.svg": 98409,
	"./videoConference.svg": 28575,
	"./virtualOffices.svg": 80038,
	"./wC.svg": 43575,
	"./wifi.svg": 74726,
	"./yoga.svg": 75703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54084;